module.exports = __webpack_public_path__ + "static/img/blnxy.d135964.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/blnxy.png
// module id = Cr0/
// module chunks = 18